import { mapToCamelCase } from '@consigli/utils';
import { z } from 'zod';
import { languageSchema } from './language';
import { projectSchema } from './project';
export var DocumentPackageType;
(function (DocumentPackageType) {
    DocumentPackageType["TENDER_DOCUMENTS"] = "TENDER_DOCUMENTS";
    DocumentPackageType["OFFER"] = "OFFER";
    DocumentPackageType["TENANT_SPECIFICATION"] = "TENANT_SPECIFICATION";
    DocumentPackageType["DUE_DILIGENCE"] = "DUE_DILIGENCE";
    DocumentPackageType["SITE_DUE_DILIGENCE"] = "SITE_DUE_DILIGENCE";
    DocumentPackageType["MANAGEMENT_OPERATIONS_MAINTENANCE"] = "MANAGEMENT_OPERATIONS_MAINTENANCE";
    DocumentPackageType["TENANT_REQUIREMENTS"] = "TENANT_REQUIREMENTS";
    DocumentPackageType["SCHEDULE_CHECK"] = "SCHEDULE_CHECK";
    DocumentPackageType["CONTRACT_REVIEW"] = "CONTRACT_REVIEW";
    DocumentPackageType["REPORT_GENERATION"] = "REPORT_GENERATION";
    DocumentPackageType["LUMINAIRE_SCHEDULE"] = "LUMINAIRE_SCHEDULE";
    DocumentPackageType["RFP_RFQ_REVIEW"] = "RFP_RFQ_REVIEW";
    DocumentPackageType["DESIGN_PACKAGE_REVIEW"] = "DESIGN_PACKAGE_REVIEW";
    DocumentPackageType["VERSION_COMPARE"] = "VERSION_COMPARE";
    DocumentPackageType["WATER_PROCESS_SYSTEMS_AGENT"] = "WATER_PROCESS_SYSTEMS_AGENT";
})(DocumentPackageType || (DocumentPackageType = {}));
export const DocumentPackageTypeLabels = {
    [DocumentPackageType.TENDER_DOCUMENTS]: 'Tender Review',
    [DocumentPackageType.OFFER]: 'Bid Review',
    [DocumentPackageType.TENANT_SPECIFICATION]: 'Tenant Specification',
    [DocumentPackageType.DUE_DILIGENCE]: 'Due Diligence',
    [DocumentPackageType.SITE_DUE_DILIGENCE]: 'Site Due Diligence',
    [DocumentPackageType.MANAGEMENT_OPERATIONS_MAINTENANCE]: 'Handover',
    [DocumentPackageType.TENANT_REQUIREMENTS]: 'Tenant Requirements',
    [DocumentPackageType.SCHEDULE_CHECK]: 'Component Reference Checker',
    [DocumentPackageType.CONTRACT_REVIEW]: 'Contract Review',
    [DocumentPackageType.REPORT_GENERATION]: 'Report Generation',
    [DocumentPackageType.LUMINAIRE_SCHEDULE]: 'Luminaire Schedule',
    [DocumentPackageType.RFP_RFQ_REVIEW]: 'RFP Review',
    [DocumentPackageType.DESIGN_PACKAGE_REVIEW]: 'Design Package Review',
    [DocumentPackageType.VERSION_COMPARE]: 'Version Compare',
    [DocumentPackageType.WATER_PROCESS_SYSTEMS_AGENT]: 'Water & Process Systems Agent',
};
export var RfpRegion;
(function (RfpRegion) {
    RfpRegion["ANZ"] = "anz";
    RfpRegion["ASIA"] = "asia";
    RfpRegion["CANADA"] = "canada";
    RfpRegion["CANADA_FRENCH"] = "canada_french";
    RfpRegion["CM"] = "cm";
    RfpRegion["ENTERPRISE"] = "enterprise";
    RfpRegion["EUI"] = "eui";
    RfpRegion["MEA"] = "mea";
    RfpRegion["US_EAST"] = "us_east";
    RfpRegion["US_WEST"] = "us_west";
})(RfpRegion || (RfpRegion = {}));
export const RfpRegionLabels = {
    [RfpRegion.ENTERPRISE]: '3-Enterprise Minimum Requirements',
    [RfpRegion.CM]: 'Group-specific Requirements - CM',
    [RfpRegion.ANZ]: 'Region-specific Requirements - ANZ',
    [RfpRegion.ASIA]: 'Region-specific Requirements - Asia',
    [RfpRegion.CANADA]: 'Region-specific Requirements - CAN',
    [RfpRegion.CANADA_FRENCH]: 'Region-specific Requirements - CAN (French)',
    [RfpRegion.EUI]: 'Region-specific Requirements - EU&I',
    [RfpRegion.MEA]: 'Region-specific Requirements - MEA',
    [RfpRegion.US_EAST]: 'Region-specific Requirements - US-E',
    [RfpRegion.US_WEST]: 'Region-specific Requirements - US-W',
};
export var SiteDueDiligenceFacilityType;
(function (SiteDueDiligenceFacilityType) {
    SiteDueDiligenceFacilityType["DATA_CENTER"] = "DATA_CENTER";
    SiteDueDiligenceFacilityType["WASTE_WATER"] = "WASTE_WATER";
    SiteDueDiligenceFacilityType["LOGISTIC"] = "LOGISTIC";
    SiteDueDiligenceFacilityType["BRIDGE"] = "BRIDGE";
})(SiteDueDiligenceFacilityType || (SiteDueDiligenceFacilityType = {}));
export var EmployerRole;
(function (EmployerRole) {
    EmployerRole["CONTRACTOR"] = "CONTRACTOR";
    EmployerRole["DEVELOPER"] = "DEVELOPER";
    EmployerRole["PROJECT_DEVELOPER"] = "PROJECT_DEVELOPER";
    EmployerRole["ENGINEER"] = "ENGINEER";
    EmployerRole["CONSULTANT"] = "CONSULTANT";
})(EmployerRole || (EmployerRole = {}));
export const documentPackageSchema = z
    .object({
    id: z.string().uuid(),
    name: z.string(),
    project: projectSchema.innerType().shape.id,
    type: z.nativeEnum(DocumentPackageType),
    external_famac_building_id: z.string().uuid().nullable(),
    language: languageSchema.optional(),
    created_by: z.string().uuid().nullable(),
    published: z.boolean(),
    needClassification: z.boolean(),
    is_hidden: z.boolean(),
    selected_conflict_types: z.array(z.string()).optional().default([]),
    employer_role: z.nativeEnum(EmployerRole).nullable().optional(),
    data: z.record(z.string(), z.unknown()).optional().default({}),
})
    .strict()
    .transform(mapToCamelCase);
// GET /projects/:projectId/packages/
export const getPackagesResponseSchema = z.array(documentPackageSchema).transform(mapToCamelCase);
// POST /projects/:projectId/packages/
export const createPackageResponseSchema = documentPackageSchema;
